import React from "react";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "./ui/accordion";
import { useLanguage } from "../i18n/LanguageContext";
import { FAQS_EN, FAQS_ES } from "../data/services";

const FaqSection = ({ items, testid = "faq-section" }) => {
    const { t, lang } = useLanguage();
    const faqs = items || (lang === "es" ? FAQS_ES : FAQS_EN);

    return (
        <section
            data-testid={testid}
            className="bg-[#FFFFF3] py-24 md:py-32 border-t border-[#3D3D24]/10"
        >
            <div className="max-w-[1100px] mx-auto px-6 grid lg:grid-cols-[1fr_1.4fr] gap-14 lg:gap-20">
                <div>
                    <div className="font-label text-[11px] text-[#D4A95A] mb-5">
                        {t.home.faqOverline}
                    </div>
                    <h2 className="font-serif text-4xl md:text-5xl text-[#3D3D24] leading-[1.05]">
                        {t.common.faqTitle}
                    </h2>
                </div>
                <Accordion type="single" collapsible className="w-full">
                    {faqs.map((f, i) => (
                        <AccordionItem
                            key={i}
                            value={`faq-${i}`}
                            data-testid={`faq-item-${i}`}
                            className="border-b border-[#3D3D24]/15"
                        >
                            <AccordionTrigger className="font-serif text-xl md:text-2xl text-[#3D3D24] text-left hover:no-underline py-6">
                                {f.q}
                            </AccordionTrigger>
                            <AccordionContent className="text-[#3D3D24]/80 leading-relaxed text-base pb-6">
                                {f.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </section>
    );
};

export default FaqSection;
